import React from "react";
import {BlockPicker, ChromePicker, SketchPicker} from "react-color";
import PropTypes from 'prop-types';

const SwitchPicker = ({type, color, onChange, name, path, colors}) => {
    switch (type) {
        case 'sketch':
            return <SketchPicker
                width={230}
                color={color}
                onChangeComplete={(color) => onChange(color, name, path)}
            />;
        case 'chrome':
            return <ChromePicker
                color={color}
                onChangeComplete={(color) => onChange(color, name, path)}
            />;
        case 'block':
            return <BlockPicker
                color={color}
                onChangeComplete={(color) => onChange(color, name, path)}
                colors={colors}
            />;
        default:
            return <SketchPicker
                color={color}
                onChangeComplete={(color) => onChange(color, name, path)}
            />;
    }
};
export default SwitchPicker

SwitchPicker.propTypes = {
    type: PropTypes.oneOf(['sketch', 'chrome', 'block']),
    color: PropTypes.string,
    onChange: PropTypes.func,
    name: PropTypes.string,
    path: PropTypes.string,
    colors: PropTypes.array //used by BlockPicker
}